export class Transform {
    constructor() {
        this.scale = 1;
        this.rotation = 0;
        this.translateX = 0;
        this.translateY = 0;
    }

    clone() {
        const newTransform = new Transform();
        newTransform.scale = this.scale;
        newTransform.rotation = this.rotation;
        newTransform.translateX = this.translateX;
        newTransform.translateY = this.translateY;
        return newTransform;
    }

    apply(ctx, visualCenter) {
        if (!visualCenter) {
            // Default transform (around top-left)
            ctx.translate(this.translateX, this.translateY);
            ctx.rotate(this.rotation * Math.PI / 180);
            ctx.scale(this.scale, this.scale);
        } else {
            // Transform around visual center
            const [centerX, centerY] = visualCenter;
            
            // First translate to the visual center plus any user translation
            ctx.translate(centerX + this.translateX, centerY + this.translateY);
            
            // Apply rotation
            ctx.rotate(this.rotation * Math.PI / 180);
            
            // Apply scaling
            ctx.scale(this.scale, this.scale);
            
            // Translate back from the visual center
            ctx.translate(-centerX, -centerY);
        }
    }

    reset() {
        this.scale = 1;
        this.rotation = 0;
        this.translateX = 0;
        this.translateY = 0;
    }
}